import { useEffect } from "react";
import { App as CapacitorApp } from "@capacitor/app";

// Android hardware back button in the app: go back in history, or close the app when
// there is nowhere to go back to. (Moved out of usePushNotifications, behaviour unchanged.)
export function useAndroidBackButton() {
    useEffect(() => {
        const handle = CapacitorApp.addListener("backButton", ({ canGoBack }) => {
            if (!canGoBack) {
                CapacitorApp.exitApp();
            } else {
                window.history.back();
            }
        });
        return () => {
            handle.then((h) => h.remove()).catch(() => undefined);
        };
    }, []);
}
